module.exports = __webpack_public_path__ + "img/category-title02-PC.9d9f62a5.png";